// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"Header_inputSearch__3Gvoc","nav":"Header_nav__3Se0U"};